import { render } from "./BaseBadge.vue?vue&type=template&id=6e46053b&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=6e46053b&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e46053b"]])

export default __exports__